import React from 'react';

import { getSignupVariantData } from '../../config/signupVariants';
import type { BuckChatConfig, OtpContext } from '../../types';
import { CodeStep } from './components/CodeStep';
import { MethodStep } from './components/MethodStep';
import { ProfileStep } from './components/ProfileStep';
import { useSignupFlow } from './hooks/useSignupFlow';

type SignupDrawerProps = {
  config: BuckChatConfig;
  context?: OtpContext;
  onSuccess: (context?: OtpContext) => void;
  onAbandoned?: (step: string) => void;
  onAnalyticsEvent?: (event: string, data: Record<string, unknown>) => void;
  variant?: string;
};

const SignupDrawer: React.FC<SignupDrawerProps> = ({
  config,
  context,
  onSuccess,
  onAbandoned,
  onAnalyticsEvent,
  variant,
}) => {
  const {
    step,
    email,
    idpToken,
    apiBaseUrl,
    handleGoogleAuth,
    handleFacebookAuth,
    handleCodeSent,
    handleVerified,
    handleSessionExpired,
  } = useSignupFlow({
    config,
    context,
    onSuccess,
    onAbandoned,
    onAnalyticsEvent,
  });

  const { drawerHeader, drawerSubtext, logoVariant } = getSignupVariantData(variant);

  if (step === 'method') {
    return (
      <MethodStep
        config={config}
        context={context}
        onCodeSent={handleCodeSent}
        onAnalyticsEvent={onAnalyticsEvent}
        handleGoogleAuth={handleGoogleAuth}
        handleFacebookAuth={handleFacebookAuth}
        header={drawerHeader}
        subtext={drawerSubtext}
        logoVariant={logoVariant}
      />
    );
  }

  if (step === 'code') {
    return (
      <CodeStep
        apiBaseUrl={apiBaseUrl}
        email={email}
        context={context}
        onVerified={handleVerified}
        onAnalyticsEvent={onAnalyticsEvent}
      />
    );
  }

  // profile step
  return (
    <ProfileStep
      apiBaseUrl={apiBaseUrl}
      email={email}
      idpToken={idpToken}
      context={context}
      onSuccess={onSuccess}
      onSessionExpired={handleSessionExpired}
      onAnalyticsEvent={onAnalyticsEvent}
    />
  );
};

export default SignupDrawer;
